module.exports = __webpack_public_path__ + "fonts/Rubik-400-hebrew67.bda074a.woff2";